import { TranslationResolver } from '../../app/localization/TranslationResolver';
import deDe from './de-de';
import enGb from './en-gb';
import frFr from './fr-fr';
import { ModuleTranslation } from './ModuleTranslation';
import nlNl from './nl-nl';
import plPl from './pl-pl';

const translations = new Map<string, ModuleTranslation>([
  ['en-gb', enGb],
  ['de-de', deDe],
  ['fr-fr', frFr],
  ['pl-pl', plPl],
  ['nl-nl', nlNl],
]);

const ModuleTranslationResolver = new TranslationResolver<ModuleTranslation>(translations, 'en-gb');

export default ModuleTranslationResolver;
